'use strict';

const { reconcileSelectedSupplier } = require('public/js/lib/supplier-state');

/**
 * Apply the currently selected dealer (returned by any location-update endpoint via
 * `LocationController::buildSelectedDealerPayload()`) to every DOM surface that displays
 * the selected dealer. Add new per-surface updaters here as more parts of the page become
 * reactive to dealer changes (PDP pricing, contact form dropdown, etc.).
 *
 * Reconciling rather than invalidating the cache is what makes page load order irrelevant: this and
 * `dealer_selection_modal.js` both write the same authoritative supplier, so neither can erase the
 * other's work depending on which response lands last.
 *
 * @param {{ hash?: string, name?: string, interactiveGarageDealerCode?: string }|null|undefined} dealer
 */
function applySelectedDealerToDom(dealer) {
	if (!dealer?.name) {
		return;
	}
	updateFindDealerTrigger(dealer);
	reconcileSelectedSupplier(dealer);
}

function clearFindDealerTrigger() {
	rp$('.find-dealer-text').each((_, element) => {
		const $element = rp$(element);
		const defaultText = $element.data('default-text');

		if (typeof defaultText === 'string') {
			$element.text(defaultText);
		}
	});
	rp$('.find-dealer-button').attr('data-ig-dealer-code', '');
}

function updateFindDealerTrigger(dealer) {
	// Match legacy dealer_selection_modal: name targets `.find-dealer-text` globally (not only under `.find-dealer-button`).
	rp$('.find-dealer-text').each((_, element) => {
		const $element = rp$(element);
		if (typeof $element.data('default-text') !== 'string') {
			$element.data('default-text', $element.text());
		}
		$element.text(dealer.name);
	});
	rp$('.find-dealer-button').attr('data-ig-dealer-code', dealer.interactiveGarageDealerCode ?? '');
}

module.exports = {
	applySelectedDealerToDom,
	clearFindDealerTrigger,
	updateFindDealerTrigger,
};
